import Model from 'flarum/common/Model';
export default class Toxicity extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  svgUrl() {
    return Model.attribute('svgUrl').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  society() {
    return Model.hasOne('society').call(this);
  }
}
flarum.reg.add('champis-exhibitions', 'common/models/Toxicity', Toxicity);